import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getContestList, deleteContest } from '../../../store/contest/actions';
import { useNavigate, Link } from 'react-router-dom';
import { DeleteConfrimationModal } from '../../../components/DeleteConfrimationModal/DeleteConfrimationModal';
import { showLoading, hideLoading } from '../../../store/loading-reducer';
import { useAdminMenuContext } from "../../../context/AdminMenuContext";
import { getContestTypes } from '../../../store/contest/actions';
import { ContestContainer } from '../../../components/admin/contest/contestContainer';

function Contest() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { contestAllList } = useSelector(state => state.contest);
    const [contestModel, setContestModel] = useState({});
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const filter = { query: '', sort: 6, visibility: true };
    const [editLink, setEditLink] = useAdminMenuContext('');

    useEffect(() => {
        document.title = 'Contest | CWP Employee Portal';
        dispatch(showLoading());
        dispatch(getContestTypes());
        setEditLink('/contest');
        console.log(editLink)
    }, []);
    useEffect(() => {
        dispatch(showLoading());
        dispatch(getContestList(filter)).unwrap().then(() => {
            dispatch(hideLoading());
        })
            .catch((error) => console.error('Error fetching contest data:', error));
    }, []);

    const handleDeleteTrigger = (contest) => {
        setContestModel({ id: contest?.baseId, title: contest?.title, message: "Are you sure you want to delete this contest" });
        setShowDeleteModal(true);
    }

    const handleContestDelete = async (item) => {
        try {
            dispatch(showLoading());
            await dispatch(deleteContest(item.id));
        } catch (error) {
            console.error('Error occurred during delete or fetch operation:', error);
        } finally {
            dispatch(hideLoading());
        }
    };

    const handleEdit = (contest) => {
        if (contest?.baseId) {
            navigate(`/siteadmin/contest/edit/${contest.baseId}`);
        }
    };

    return (
        <>
            <DeleteConfrimationModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                handleDelete={handleContestDelete}
                model={contestModel}
            />
            <div className="admin-page-wrap">
                <div className="admin-top-bar-wrap">
                    <div className="admin-top-bar-left">
                        <Link className="admin-top-bar-back" to={'/siteadmin'}>Back</Link>
                    </div>
                </div>

                <div className="pageContainer">
                    <div className="admin-page-content">
                        <div className="admin-page-title-wrap">
                            <h1 className="admin-page-heading">Contest</h1>
                            <button className="admin-button"
                                onClick={() =>
                                    navigate('/siteadmin/contest/create')
                                }
                            >
                                <span>Add Contest</span>
                                <span className="material-symbols-rounded">add</span>
                            </button>
                        </div>

                        <ContestContainer
                            contests={contestAllList}
                            onEdit={handleEdit}
                            onDelete={handleDeleteTrigger}
                        />
                    </div>
                </div>
            </div>
        </>
    );
}
export default Contest;
